import axios from 'axios';
import Cookies from 'universal-cookie';
import { loadingData } from "../components/Helper";
// Endpoints
export const ENDPOINT = process.env.REACT_APP_ENDPOINT;
export const API_VERSION = process.env.REACT_APP_API_VERSION || '2025-10-01';

// Auth Routes
export const SIGN_IN = "/users/login/mobile";
export const LOGOUT = "/users/logout";
export const VERIFY_OTP = "/users/verify";
export const GET_TOKEN = "/users/token/refresh";
export const USER_LIST = "/users";
export const TERMS_AND_CONDITIONS = "/pages/terms";

const cookies = new Cookies();


export const fetchData = async (url, method, data, token, process, res, abort_signal = false, process_type = false, endpoint = '') => {
    loadingData(true)

    var userInfo = cookies.get('user');

    var TOKEN = userInfo && userInfo.key && userInfo.key.auth_key;

    let default_lng = 'en';

    if (cookies.get('lng') && cookies.get('lng') !== undefined) {
        default_lng = cookies.get('lng');
    }

    let headers = {
        'Accept': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'X-Panda-Source': 'PandaClick',
        'X-Language': default_lng,
        'X-PandaClick-Agent': 1,
        'api-version': API_VERSION,
    };

    if (process) {
        headers = { ...headers, 'contentType': false, 'processData': false }
    } else {
        headers = { ...headers, 'Content-Type': 'application/json' }
    }

    if (token) {
        headers = { ...headers, 'Authorization': 'Bearer ' + TOKEN }
    }

    let request = {
        'method': method,
        'headers': headers,
    }

    if (abort_signal) {
        request = { ...request, 'signal': abort_signal }
    }

    if (data) {
        request = { ...request, 'body': process ? data : JSON.stringify(data) }
    }

    await fetch(`${ENDPOINT}${url}`, request).then((response) => process_type === "text" ? response.text() : (process_type === "blob" ? response.blob() : response.json())).then((json) => {
        loadingData();
        if (token && json.error && (json.error.message === "unauthorized" || json.error.message === "unauthorized.")) {
            if (getNewToken(GET_TOKEN)) {
                fetchData(url, method, data, token, process, res)
            }
        } else if (!json.records) {
            res(json)
        } else if (json.records && json.records.length > 0) {
            res(json)
        } else {
            res(json)
        }
    }).catch((error) => { console.log(error) });
}

export const getNewToken = async (url = '') => {
    let default_lng = 'en';
    var userInfo = cookies.get('user');

    let REFRESH_TOKEN = userInfo && userInfo.key && userInfo.key.refresh_key;

    if (cookies.get('lng') && cookies.get('lng') !== undefined) {
        default_lng = cookies.get('lng');
    }

    let headers = {
        'Accept': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'X-Panda-Source': 'PandaClick',
        'X-Language': default_lng,
        'X-PandaClick-Agent': 1,
        'api-version': API_VERSION,
    };

    headers = { ...headers, 'X-Refresh-Key': REFRESH_TOKEN }

    try {
        let response = await axios({
            method: 'get',
            url: `${ENDPOINT}${url}`,
            headers: headers
        });
        let newToken = response.data && response.data.data && response.data.data.user.key;
        if (newToken && userInfo && userInfo !== undefined) {
            let expirydate = new Date();
            expirydate.setDate(expirydate.getDate() + 1);
            userInfo.key = newToken;

            cookies.remove('user');

            cookies.set(
                'user', userInfo, {
                path: '/',
                expires: expirydate
            }
            );
        }
        return await response.data;
    } catch (err) {
        return err;
    }
};

export const getVoucherCampaignData = async (url = '') => {
    var s3_data
    try {
        s3_data = await axios.get(url)
        return s3_data.data
    } catch (err) {
        return s3_data
    }
}